import Heading from '@/components/atoms/Heading';
import * as S from './styles';
import { theme } from '@/styles/theme';
import { Separator } from '@/components/atoms/Separator';
import {
  PropsRecomendacaoPublicacao,
  RecomendacaoPublicacao,
} from '@/components/molecules/RecomendacaoPublicacao';
import useBreakpoint from '@/hooks/useBreakpoint';

interface RecomendacoesPublicacaoProps {
  recomendacoes: PropsRecomendacaoPublicacao[];
}

export default function RecomendacoesPublicacao(
  props: RecomendacoesPublicacaoProps,
) {
  const { recomendacoes } = props;
  const { widthWindow } = useBreakpoint();

  return (
    <S.Container>
      <Separator
        $block={false}
        $orientation="horizontal"
        style={{
          backgroundColor: theme.tokens.colors.news.separator,
          marginBottom: theme.spacing[7],
          width: '100%',
        }}
      />
      <Heading
        $priority={4}
        $size={5}
        $color={theme.tokens.colors.news.description}
        $weight="medium"
        $highContrast={false}
        $align={widthWindow < 895 ? 'center' : 'left'}
        $text={'Você pode gostar'}
        style={{
          textTransform: 'uppercase',
        }}
      />
      <S.ListagemRecomendacoes>
        {recomendacoes?.map((recomendacao, index) => (
          <RecomendacaoPublicacao key={index} {...recomendacao} />
        ))}
      </S.ListagemRecomendacoes>
    </S.Container>
  );
}
